// client/src/hooks/useCertificadosHistorico.js
import { useQuery } from '@tanstack/react-query';
import apiClient from '../services/api';
import useAlert from './useAlert';

const BASE_ROUTE = 'certificados';
const QUERY_KEY = 'certificadosHistorico';

// Histórico de certificados emitidos (menu Documentos > Certificados). Cada
// registro já vem com o HTML final gerado no momento da emissão
// (GET /certificados/gerar/:matriculaId/:templateId) — esta tela só lista/exibe.
export const useCertificadosHistorico = (params = {}, options = {}) => {
    const { setAlert } = useAlert();
    return useQuery({
        queryKey: [QUERY_KEY, params],
        queryFn: async () => {
            try {
                const { data } = await apiClient.get(`/${BASE_ROUTE}`, { params });
                return data.data || [];
            } catch (error) {
                const errorMsg = error.response?.data?.error || 'Erro ao carregar histórico de certificados.';
                setAlert(errorMsg, 'danger');
                throw error;
            }
        },
        staleTime: 1000 * 30,
        ...options,
    });
};

export const useCertificadoHistoricoById = (id, options = {}) => {
    const { setAlert } = useAlert();
    return useQuery({
        queryKey: [QUERY_KEY, id],
        queryFn: async () => {
            try {
                const { data } = await apiClient.get(`/${BASE_ROUTE}/${id}`);
                return data.data || null;
            } catch (error) {
                const errorMsg = error.response?.data?.error || 'Erro ao carregar o certificado.';
                setAlert(errorMsg, 'danger');
                throw error;
            }
        },
        enabled: !!id,
        ...options,
    });
};
